export default {
    apiBaseUrl: 'https://api.medau-therapie.de/api',
    imageBaseUrl: 'https://api.medau-therapie.de',
    apiKey: '60fa03f6d007afbbec3d0464f39dc3354d9a6a7ab484bb4dc3dfe9829d6b5129ce8698d9bf905a7aed98c516d22974e9545b44b' +
        '83ff617bb85d1240137e2385dbd9f97a91a0856f541969788aa36b9e59b34e45fdd6bd9fa3be06403c14c86777f273a26a742ebb4f5' +
        'e200ef7451b188524813e9f70ab11cf1608b20a2fa07a4',
    // apiBaseUrl: 'http://127.0.0.1:1337/api',
    // imageBaseUrl: 'http://127.0.0.1:1337',
    // apiKey: '183309cac358d7854402d47879209f319913e2e6c9f97e320f8e1221b6a05bdfa42dcd4bce4919b4588679e2ee41a9637d3f4c0' +
    //     'f2224054a5a96181069c353ac556c1e56b7e4ef3b2033d5bd836027275351051763110045707f79395948c30c8e2c300daaa5b79aa7' +
    //     '02591a0887504f2187fa909c555b54ab934c4c623d8a0c',
}